export default __webpack_public_path__ + "static/media/icon_arrow.251dbc23.svg";